import styled from 'styled-components';

export const Title = styled.h2`
  font-size: 1.5rem;
  margin-bottom: 1.75rem;
`;
